import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clients, getChantiersByClient } from '../utils/mockData';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Search, Star, Phone, Mail, MapPin, Briefcase } from 'lucide-react';
import { motion } from 'framer-motion';
export function Clients() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [showStrategicOnly, setShowStrategicOnly] = useState(false);
  const filteredClients = clients.filter(client => {
    const matchesSearch = client.raisonSociale.toLowerCase().includes(search.toLowerCase()) || client.contactName.toLowerCase().includes(search.toLowerCase());
    const matchesFilter = !showStrategicOnly || client.isStrategicAccount;
    return matchesSearch && matchesFilter;
  });
  return <div className="min-h-screen bg-gray-50 pb-20 md:pb-6" data-id="element-486">
      <div className="page-container section-spacing" data-id="element-487">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-488">
          <div data-id="element-489">
            <h1 className="heading-xl" data-id="element-490">Clients</h1>
            <p className="text-caption mt-1" data-id="element-491">
              {clients.length} client{clients.length > 1 ? 's' : ''} ·{' '}
              {clients.filter(c => c.isStrategicAccount).length} compte
              {clients.filter(c => c.isStrategicAccount).length > 1 ? 's' : ''}{' '}
              stratégique
              {clients.filter(c => c.isStrategicAccount).length > 1 ? 's' : ''}
            </p>
          </div>
        </div>

        {/* Search & Filters */}
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-492">
          <div className="relative flex-1" data-id="element-493">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-494" />
            <input type="text" placeholder="Rechercher un client..." className="input-base pl-10 w-full" value={search} onChange={e => setSearch(e.target.value)} data-id="element-495" />
          </div>

          <button onClick={() => setShowStrategicOnly(!showStrategicOnly)} className={`px-4 py-2 rounded-lg font-medium transition-all flex items-center gap-2 ${showStrategicOnly ? 'bg-[#1DBAB4] text-white shadow-md' : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'}`} data-id="element-496">
            <Star size={16} className={showStrategicOnly ? 'fill-current' : ''} data-id="element-497" />
            Comptes stratégiques
          </button>
        </div>

        {/* Clients Grid */}
        {filteredClients.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-498">
            {filteredClients.map((client, index) => {
          const chantiers = getChantiersByClient(client.id);
          const activeChantiers = chantiers.filter(ch => ch.status === 'en_cours');
          return <motion.div key={client.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.05
          }} data-id="element-499">
                  <Card className="p-6 space-y-4" onClick={() => navigate(`/clients/${client.id}`)} data-id="element-500">
                    {/* Header */}
                    <div className="flex items-start justify-between gap-2" data-id="element-501">
                      <div className="flex-1 min-w-0" data-id="element-502">
                        <h3 className="text-lg font-bold text-gray-900 truncate group-hover:text-[#1DBAB4] transition-colors" data-id="element-503">
                          {client.raisonSociale}
                        </h3>
                        <p className="text-sm text-gray-600 mt-1" data-id="element-504">
                          {client.contactName}
                        </p>
                      </div>
                      {client.isStrategicAccount && <div className="flex-shrink-0 w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center" data-id="element-505">
                          <Star size={16} className="text-amber-600 fill-current" data-id="element-506" />
                        </div>}
                    </div>

                    {/* Contact Info */}
                    <div className="space-y-2 text-sm" data-id="element-507">
                      <div className="flex items-center gap-2 text-gray-600" data-id="element-508">
                        <Phone size={14} className="text-gray-400" data-id="element-509" />
                        <span className="truncate" data-id="element-510">{client.phone}</span>
                      </div>
                      {client.email && <div className="flex items-center gap-2 text-gray-600" data-id="element-511">
                          <Mail size={14} className="text-gray-400" data-id="element-512" />
                          <span className="truncate" data-id="element-513">{client.email}</span>
                        </div>}
                      <div className="flex items-center gap-2 text-gray-600" data-id="element-514">
                        <MapPin size={14} className="text-gray-400" data-id="element-515" />
                        <span className="truncate" data-id="element-516">
                          {client.sites.length} site
                          {client.sites.length > 1 ? 's' : ''}
                        </span>
                      </div>
                    </div>

                    {/* Stats */}
                    <div className="pt-4 border-t border-gray-100 grid grid-cols-2 gap-4" data-id="element-517">
                      <div data-id="element-518">
                        <div className="text-2xl font-bold text-gray-900" data-id="element-519">
                          {chantiers.length}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-520">
                          Chantier{chantiers.length > 1 ? 's' : ''}
                        </div>
                      </div>
                      <div data-id="element-521">
                        <div className="text-2xl font-bold text-[#1DBAB4]" data-id="element-522">
                          {activeChantiers.length}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-523">En cours</div>
                      </div>
                    </div>
                  </Card>
                </motion.div>;
        })}
          </div> : <Card hover={false} className="p-12 text-center" data-id="element-524">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-525">
              <Search className="text-gray-400" size={32} data-id="element-526" />
            </div>
            <h3 className="text-lg font-medium text-gray-900" data-id="element-527">
              Aucun client trouvé
            </h3>
            <p className="text-gray-500 mt-1" data-id="element-528">
              Essayez de modifier vos critères de recherche.
            </p>
          </Card>}
      </div>
    </div>;
}